// NATIVE
import React from 'react';

// INSTALLED

// CUSTOM
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { Divider, Grid } from '@mui/material';
import InputField from '../../formFields/InputField';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';

/**
 * EditTipoNovedad component is used to edit the details of a specific "Tipo Novedad".
 * It utilizes Formik for form management and Redux for state management.
 *
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered component.
 *
 * @example
 * <EditTipoNovedad
 *   formField={{
 *     e_name: { name: 'name', label: 'Name' },
 *     e_description: { name: 'description', label: 'Description' },
 *     e_accion_1: { name: 'accion_1', label: 'Action 1' },
 *     e_resultado_1: { name: 'resultado_1', label: 'Result 1' },
 *     e_cantidad_1: { name: 'cantidad_1', label: 'Quantity 1' },
 *     e_accion_2: { name: 'accion_2', label: 'Action 2' },
 *     e_resultado_2: { name: 'resultado_2', label: 'Result 2' },
 *     e_cantidad_2: { name: 'cantidad_2', label: 'Quantity 2' },
 *     e_accion_3: { name: 'accion_3', label: 'Action 3' },
 *     e_resultado_3: { name: 'resultado_3', label: 'Result 3' },
 *     e_cantidad_3: { name: 'cantidad_3', label: 'Quantity 3' },
 *     e_accion_4: { name: 'accion_4', label: 'Action 4' },
 *     e_resultado_4: { name: 'resultado_4', label: 'Result 4' },
 *     e_cantidad_4: { name: 'cantidad_4', label: 'Quantity 4' }
 *   }}
 * />
 *
 * @component
 *
 * @example
 * // Example usage:
 * <EditTipoNovedad
 *   formField={{
 *     e_name: { name: 'name', label: 'Name' },
 *     e_description: { name: 'description', label: 'Description' },
 *     e_accion_1: { name: 'accion_1', label: 'Action 1' },
 *     e_resultado_1: { name: 'resultado_1', label: 'Result 1' },
 *     e_cantidad_1: { name: 'cantidad_1', label: 'Quantity 1' },
 *     e_accion_2: { name: 'accion_2', label: 'Action 2' },
 *     e_resultado_2: { name: 'resultado_2', label: 'Result 2' },
 *     e_cantidad_2: { name: 'cantidad_2', label: 'Quantity 2' },
 *     e_accion_3: { name: 'accion_3', label: 'Action 3' },
 *     e_resultado_3: { name: 'resultado_3', label: 'Result 3' },
 *     e_cantidad_3: { name: 'cantidad_3', label: 'Quantity 3' },
 *     e_accion_4: { name: 'accion_4', label: 'Action 4' },
 *     e_resultado_4: { name: 'resultado_4', label: 'Result 4' },
 *     e_cantidad_4: { name: 'cantidad_4', label: 'Quantity 4' }
 *   }}
 * />
 */
export const EditTipoNovedad = (props: any) => {
  // USE FORMIK
  const formikProps: any = useFormikContext();

  // USE SELECTOR
  const { tiponovedad } = useSelector((state: any) => state.tiponovedades);
  const { actionTipoNovedadesSelect } = useSelector((state: any) => state.actionTipoNovedad);
  const { resultTipoNovedadesSelect } = useSelector((state: any) => state.resultTipoNovedad);

  // USE EFFECT
  React.useEffect(() => {
    if (tiponovedad && typeof tiponovedad === 'object' && Object.keys(tiponovedad).length > 0) {
      setData(tiponovedad);
    }
  }, [tiponovedad]);

  // FORM FIELDS
  const {
    formField: {
      e_name,
      e_description,
      e_accion_1,
      e_resultado_1,
      e_cantidad_1,
      e_accion_2,
      e_resultado_2,
      e_cantidad_2,
      e_accion_3,
      e_resultado_3,
      e_cantidad_3,
      e_accion_4,
      e_resultado_4,
      e_cantidad_4,
    },
  } = props;

  // CONST FUNCTIONS
  const setData = (edTipoNovedad: any) => {
    // ID CARGO
    formikProps.setFieldValue('tipoNovedadId', edTipoNovedad.id);

    // DATOS BASICOS

    formikProps.setFieldValue('e_name', edTipoNovedad.name);
    formikProps.setFieldValue('e_description', edTipoNovedad.description);

    for (let index = 0; index < edTipoNovedad.items.length; index++) {
      formikProps.setFieldValue(`e_accion_${index + 1}`, edTipoNovedad.items[index].action.name);
      formikProps.setFieldValue(`e_resultado_${index + 1}`, edTipoNovedad.items[index].result.name);
      formikProps.setFieldValue(`e_cantidad_${index + 1}`, edTipoNovedad.items[index].quantity);
    }
    // formikProps.setFieldValue('e_accion_1', edTipoNovedad.accion_1);
    // formikProps.setFieldValue('e_resultado_1', edTipoNovedad.resultado_1);
    // formikProps.setFieldValue('e_cantidad_1', edTipoNovedad.cantidad_1);
    // formikProps.setFieldValue('e_accion_2', edTipoNovedad.accion_2);
    // formikProps.setFieldValue('e_resultado_2', edTipoNovedad.resultado_2);
    // formikProps.setFieldValue('e_cantidad_2', edTipoNovedad.cantidad_2);
    // formikProps.setFieldValue('e_accion_3', edTipoNovedad.accion_3);
    // formikProps.setFieldValue('e_resultado_3', edTipoNovedad.resultado_3);
    // formikProps.setFieldValue('e_cantidad_3', edTipoNovedad.cantidad_3);
    // formikProps.setFieldValue('e_accion_4', edTipoNovedad.accion_4);
    // formikProps.setFieldValue('e_resultado_4', edTipoNovedad.resultado_4);
    // formikProps.setFieldValue('e_cantidad_4', edTipoNovedad.cantidad_4);
  };

  // const actionTipoNovedadesSelect:any = [
  //     {
  //         "label":  "",
  //         "value":  "SELECCIONAR"
  //     },
  //     {
  //         "label":  "LLAMADO VERBAL",
  //         "value":  "1"
  //     },
  //     {
  //         "label":  "LLAMADO DE ATENCIÓN POR ESCRITO",
  //         "value":  "2"
  //     },
  //     {
  //         "label":  "SUSPENCIÓN DE CONTRATO",
  //         "value":  "3"
  //     },

  // ];

  // const resultTipoNovedadesSelect:any = [
  //     {
  //         "label":  "",
  //         "value":  "SELECCIONAR"
  //     },
  //     {
  //         "label":  "VERBAL",
  //         "value":  "1"
  //     },
  //     {
  //         "label":  "SUSPENCIÓN",
  //         "value":  "2"
  //     },

  // ];

  const cantidad_list: any = [
    {
      label: '',
      value: 'SELECCIONAR',
    },
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6',
      value: '6',
    },
    {
      label: '7',
      value: '7',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '9',
      value: '9',
    },
    {
      label: '10',
      value: '10',
    },
  ];

  return (
    <div>
      <Grid container>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <InputField
            name={e_name.name}
            label={e_name.label}
            variant="outlined"
            fullWidth
            autoComplete="off"
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <TextAreaField
            name={e_description.name}
            label={e_description.label}
            variant="outlined"
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={actionTipoNovedadesSelect}
            name={e_accion_1.name}
            label={e_accion_1.label}
            element={e_accion_1.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={resultTipoNovedadesSelect}
            name={e_resultado_1.name}
            label={e_resultado_1.label}
            element={e_resultado_1.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={cantidad_list}
            name={e_cantidad_1.name}
            label={e_cantidad_1.label}
            element={e_cantidad_1.name}
          />
        </Grid>

        <Divider />

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={actionTipoNovedadesSelect}
            name={e_accion_2.name}
            label={e_accion_2.label}
            element={e_accion_2.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={resultTipoNovedadesSelect}
            name={e_resultado_2.name}
            label={e_resultado_2.label}
            element={e_resultado_2.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={cantidad_list}
            name={e_cantidad_2.name}
            label={e_cantidad_2.label}
            element={e_cantidad_2.name}
          />
        </Grid>

        <Divider />

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={actionTipoNovedadesSelect}
            name={e_accion_3.name}
            label={e_accion_3.label}
            element={e_accion_3.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={resultTipoNovedadesSelect}
            name={e_resultado_3.name}
            label={e_resultado_3.label}
            element={e_resultado_3.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={cantidad_list}
            name={e_cantidad_3.name}
            label={e_cantidad_3.label}
            element={e_cantidad_3.name}
          />
        </Grid>

        <Divider />

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={actionTipoNovedadesSelect}
            name={e_accion_4.name}
            label={e_accion_4.label}
            element={e_accion_4.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={resultTipoNovedadesSelect}
            name={e_resultado_4.name}
            label={e_resultado_4.label}
            element={e_resultado_4.name}
          />
        </Grid>

        <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={cantidad_list}
            name={e_cantidad_4.name}
            label={e_cantidad_4.label}
            element={e_cantidad_4.name}
          />
        </Grid>

        <Divider />
      </Grid>
    </div>
  );
};
